import { outlinedInputClasses, paperClasses } from '@mui/material';
import CaretDownIcon from '../../icons/CaretDownIcon';

// eslint-disable-next-line import/prefer-default-export
export const muiSelectComponent = {
  defaultProps: {
    IconComponent: CaretDownIcon,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      [`.${paperClasses.root}`]: {
        marginTop: theme.spacing('SMALL'),
      },
    }),
    select: ({ theme }) => ({
      [`&.${outlinedInputClasses.input}`]: {
        paddingRight: theme.spacing('4XL'),
      },
    }),
    icon: ({ theme }) => ({
      height: theme.spacing('1XL'),
      right: theme.spacing('MEDIUM'),
      top: `calc(50% - ${theme.spacing('MEDIUM')})`,
      width: theme.spacing('1XL'),

      [`&.Mui-disabled path`]: {
        stroke: theme.palette.gray.gray,
      },
    }),
  },
};
